import { render, staticRenderFns } from "./ProcessPenalty.vue?vue&type=template&id=4c8630c8"
import script from "./ProcessPenalty.vue?vue&type=script&lang=js"
export * from "./ProcessPenalty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports